export default __webpack_public_path__ + "3bc90a0e2bab385e722bc0831484ba97.png";